import { c as _c } from "react/compiler-runtime";
import { RemoteIcon } from "@/components/icons/remote-icon";
import { useTRPC } from "@/lib/trpc/client";
export function ProviderLogo(t0) {
  const $ = _c(12);
  const {
    providerId,
    providerName,
    size: t1,
    className,
    style
  } = t0;
  const size = t1 === undefined ? 16 : t1;
  const trpc = useTRPC();
  if (!providerId) {
    return null;
  }
  const fallbackIdentifier = providerName || "?";
  let t2;
  if ($[0] !== providerId || $[1] !== trpc.provider.getProviderIcon) {
    t2 = trpc.provider.getProviderIcon.queryOptions({
      providerId
    }, {
      staleTime: Number.POSITIVE_INFINITY
    });
    $[0] = providerId;
    $[1] = trpc.provider.getProviderIcon;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t2) {
    t3 = {
      ...t2
    };
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const t4 = `${providerName || fallbackIdentifier} logo`;
  let t5;
  if ($[5] !== className || $[6] !== fallbackIdentifier || $[7] !== size || $[8] !== style || $[9] !== t3 || $[10] !== t4) {
    t5 = <RemoteIcon queryOptions={t3} fallbackIdentifier={fallbackIdentifier} size={size} className={className} style={style} alt={t4} dataAttribute="data-provider-logo" />;
    $[5] = className;
    $[6] = fallbackIdentifier;
    $[7] = size;
    $[8] = style;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return t5;
}